import React from 'react';

import Text from 'components/shared/Typography/Text';

import { TotalCostInfo } from '../../../../../Itinerary/Landing/Costs';
import Document from './Document';
import Header from './Header';
import TextBlock from './Text';

const defaultConfig = {
  header: {
    Component: Header,
  },
  text: {
    Component: TextBlock,
  },
  totalCosts: {
    Component: (props) => (
      <Text>
        <TotalCostInfo {...props.block.data} />
      </Text>
    ),
  },
  document: {
    Component: Document,
  },
};

export function getBlockConfig({ type }) {
  if (!defaultConfig[type]) {
    return { Component: null };
  }

  return defaultConfig[type];
}
